import { get } from 'svelte/store';
import type { PromptOptions } from '@rool-dev/sdk';

type PromptEffort = NonNullable<PromptOptions['effort']>;
import { channel } from '../stores';
import { rebuildGraph } from './graph';

export async function handlePromptSubmit(
	prompt: string,
	objectIds?: string[],
	effort?: PromptEffort,
): Promise<void> {
	const currentChannel = get(channel);

	if (!currentChannel) return;

	try {
		await currentChannel.checkpoint('prompt');
		await currentChannel.prompt(prompt, { objectIds, effort });

		rebuildGraph();
	} catch (error) {
		console.error('Error running prompt:', error);
	}
}
